module.exports = __webpack_public_path__ + "assets/be7180c200f054f23886e703da424589.svg";